import { ENVIRONMENT_NAMES, ENVIRONMENT_NAMES_ARRAY } from './environments'

const environmentName = process.env.REACT_APP_ENVIRONMENT_NAME

const IS_ENV_PROD = environmentName === ENVIRONMENT_NAMES.prod
const IS_ENV_QA = environmentName === ENVIRONMENT_NAMES.qa
const IS_ENV_DEV = environmentName === ENVIRONMENT_NAMES.dev
const IS_ENV_LOCAL = environmentName === ENVIRONMENT_NAMES.local
const IS_ENV_EPHEMERAL = !ENVIRONMENT_NAMES_ARRAY.includes(
  environmentName ?? '',
)

export { IS_ENV_PROD, IS_ENV_QA, IS_ENV_DEV, IS_ENV_LOCAL, IS_ENV_EPHEMERAL }
